import { z } from 'zod';

import commonLocales from 'common/zod/locales';
import { capitalizeFirstLetter } from 'helpers/string';

export const memberInformationFormSchema = z.object({
  inviteeEmail: z
    .string({
      invalid_type_error: commonLocales.errors.required,
      required_error: commonLocales.errors.required,
    })
    .email({ message: commonLocales.errors.invalidEmail }),
  inviteeFirstName: z
    .string()
    .trim()
    .transform((str) => capitalizeFirstLetter(str)),
  inviteeLastName: z.string().trim().toUpperCase(),
});

export type MemberInformationFormSchema = z.infer<
  typeof memberInformationFormSchema
>;
